import { Shape } from '../../Edit2D/EditShapes.js';

// Return true if locationA is a descendant of locationB.
function isDescendant(locationA, locationB) {
    if (!locationA || !locationB) {
        return false;
    }

    if (locationA === locationB) {
        return true;
    }

    return isDescendant(locationA.parent, locationB);
}

// Given a point and location list, return all the locations that the point is inside of them.
export function getPointLocations(point, locations) {
    let candidates = [];

    // For each location on the list, check if we have an intersection.
    // In case of overlap, push both candidates.
    for (let i = 0; i < locations.length; i++) {
        const location = locations[i];

        if (location.polygon.hitTest(point.x, point.y)) {
            candidates.push(location);
        }
    }

    // If one candidate is a parent of another, keep only the descendant.
    for (let i = 0; i < candidates.length-1; i++) {
        for (let j = i + 1; j < candidates.length; j++) {
            if (isDescendant(candidates[i], candidates[j])) {
                // Note the we remove the location node only from the candidates array - we are not deleting the parent itself.
                candidates[j] = null;
            } else if (isDescendant(candidates[j], candidates[i])) {
                candidates[i] = null;
            }
        }
    }

    // Filter the candidates that we removed in previous step.
    candidates = candidates.filter(e => e);

    return candidates;
}

// Given locations metadata array, return a new array of the form [{ metadata, polygon, parent }].
export function parseLocationsMetadata(locationsMetadata) {
    const locationsMap = {};

    const locations = locationsMetadata.map((metadata) => {
        if (metadata.area) {
            if (metadata.area.format === 'Svg') {
                const polygon = Shape.fromSVG(metadata.area.geometry);
                polygon.name = metadata.name;

                // Depends on the API that is being used, "id" attribute can be located in a different place.
                // When using `getTreeDocuments` API, the id will be located under `node` object.
                // When using `node:search` API, the id will be located on the root.
                const id = (metadata.node && metadata.node.id) || metadata.id;

                const location = {
                    id,
                    metadata,
                    polygon,
                    parent: undefined
                };

                locationsMap[id] = location;

                return location;
            }
        }
    }).filter(e => e);

    // The location list the we get from the BE is flat.
    // Traverse and link every location to its parent.
    locations.forEach((location) => {
        // Depends on the API that is being used, "parentId" attribute can be located in a different place.
        // When using `getTreeDocuments` API, the parentId will be located under `node` object.
        // When using `node:search` API, the parentId will be located on the root.
        const parentId = (location.metadata.node && location.metadata.node.parentId) || location.metadata.parentId;
        location.parent = locationsMap[parentId];
    });

    return locations;
}
